import { render, staticRenderFns } from "./PersonalPage.vue?vue&type=template&id=589bd9db&scoped=true"
import script from "./PersonalPage.vue?vue&type=script&lang=js"
export * from "./PersonalPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalPage.vue?vue&type=style&index=0&id=589bd9db&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589bd9db",
  null
  
)

export default component.exports